import { getFeatureFlagValue } from '@atlassian/jira-portfolio-3-common/src/feature-flags';

const getCommitScenarioChangesBatchSize = () =>
	Number(
		getFeatureFlagValue('com.atlassian.rm.jpo.jpo3cloud.commit-scenario-changes-batch-size', 5),
	);

export default getCommitScenarioChangesBatchSize;
